import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment/moment';
import { translateOutOrderStatus } from 'src/app/helpers/translate-out-order-status';
import { OutOrderStateEnum } from 'src/models/OutOrder';

@Component({
  selector: 'app-picking-group-in-execution-item',
  templateUrl: './picking-group-in-execution-item.component.html',
  styleUrls: ['./picking-group-in-execution-item.component.scss']
})
export class PickingGroupInExecutionItemComponent implements OnInit {
  @Input() item;
  @HostBinding('class.isOdd') @Input() isOdd;
  date;
  @Output() openNfeConfirmModalEvent = new EventEmitter();
  @Output() openFakeNfeModalEvent = new EventEmitter();
  @Output() goToDetails: EventEmitter<any> = new EventEmitter();
  @Output() openInventorySidenavEvent = new EventEmitter();
  @Output() openReport: EventEmitter<any> = new EventEmitter();
  statusEnum = OutOrderStateEnum;

  constructor() { }

  ngOnInit(): void {
    this.date = moment(this.item.issuedAt).format('DD/MM/YYYY - HH:mm');
  }

  openConfirmModal(item) {
    this.openNfeConfirmModalEvent.emit(item);
  }

  openFakeNfeModal(item) {
    this.openFakeNfeModalEvent.emit(item);
  }

  emulateNfe(item) {
    this.openFakeNfeModalEvent.emit(item);
  }

  createInventory(item) {
    this.openInventorySidenavEvent.emit(item);
  }

  translateStatus(status) {
    return translateOutOrderStatus(status);
  }

  openDetailsModal(): void {
    this.goToDetails.emit(this.item);
  }

  goToReport(item) {
    this.openReport.emit(item);
  }
}
